import { getCurrentDate } from "../../utils/getCurrentDate";

export const docValuesDefault = (key: string) => {
  switch (key) {
    case "FEC":
      return getCurrentDate(true);
    case "FEC2":
    case "NOM":
    case "NRS":
    case "DOM":
    case "TEL":
    case "CEL":
    case "EMA":
    case "ANO":
    case "CNO":
    case "RNO":
    case "ALM":
    case "OBS":
    case "NOT":
    case "UMO":
    case "NAB":
    case "PAI":
    case "QR":
    case "GPS":
    case "POL":
    case "CLI":
    case "GAR":
      return "";
    default:
      return 0;
  }
};
